// Indonesian Translation
export default {
  // Navigation
  navHome: 'Beranda',
  navMethod: 'Metode TSMC',
  navServices: 'Layanan',
  navAbout: 'Tentang Kami',
  navFaq: 'FAQ',
  navContact: 'Kontak & Reservasi',
  navBlog: 'BLOG',
  
  // Buttons
  bookNow: 'Pesan Sekarang',
  lineConsult: 'Konsultasi LINE',
  bookNowFull: 'Pesan Sekarang',
  
  // Hero
  heroTitle1: 'Presisi Insinyur',
  heroTitle2: 'Memulihkan Struktur Tubuh',
  heroSubtitle: 'Chiropractic & Pijat Olahraga Profesional Tainan Jiali',
  heroDesc: 'Mengintegrasikan Teknik Terbaik dari AS, Jepang, Australia, Kanada | Pelepasan Fascia Dalam | Mekanika Struktural',
  heroCert: 'Bersertifikat Multi-negara',
  heroPrice: 'Harga Transparan',
  heroTime: 'Buka Sab-Rab',
  
  // What is Chiropractic
  whatIsTitle: 'Apa itu',
  whatIsChiro: 'Chiropractic Amerika',
  whatIsSubtitle: "Chiropractic schools and manual traditions",
  whatIsPara1: "In some international systems, ",
  whatIsChiroFull: "Chiropractic",
  whatIsPara1b: " is a manual tradition that originated in the United States and was founded by ",
  whatIsFounder: 'Daniel David Palmer',
  whatIsPara1c: " in 1895. The following describes that school’s perspective.",
  whatIsPara2: "Within that tradition, specific manual methods are used to consider joint movement and whole-body use, ",
  whatIsRestore: "with adjustments guided by personal comfort",
  whatIsPara2b: "; this is not a disease diagnosis, medical treatment, or guarantee of a specific result.",
  whatIsBoxTitle: "Understanding daily body use as a whole",
  whatIsBoxDesc: "This approach considers daily loading, movement habits, and how different areas work together:",
  whatIsCycle1: "Repeated demands from work or exercise",
  whatIsCycle2: "Muscle tension and movement habits can influence each other",
  whatIsCycle3: "Different areas coordinate and compensate during movement",
  whatIsCycle4: "Look at everyday body use from a whole-body perspective",
  chiroCardTitle: 'Chiropractic Amerika',
  chiroCardDesc: 'Spesialisasi dalam',
  chiroCardFocus: 'penyesuaian tulang',
  chiroCardDesc2: ', memulihkan mobilitas sendi normal melalui teknik yang tepat',
  massageCardTitle: 'Pijat Olahraga',
  massageCardDesc: 'Spesialisasi dalam',
  massageCardFocus: 'relaksasi otot',
  massageCardDesc2: ', melepaskan ketegangan fascia dalam dan memperbaiki ketidakseimbangan otot',
  whatIsSummary: 'TSMC menggabungkan kedua metode',
  whatIsSummary2: ', mengidentifikasi sistem mana yang menyebabkan masalah dan menerapkan teknik yang sesuai, mempertimbangkan "penyebab" dan "pencegahan" secara komprehensif berdasarkan mekanika dan struktur',
  
  // TSMC Method
  methodTitle: 'TSMC',
  methodTitleSuffix: 'Metode',
  methodSubtitle: 'Sistem Penyesuaian Struktur Tubuh Eksklusif TSMC',
  methodT: 'Technology',
  methodTSub: 'Integrasi Teknik Multi-negara',
  methodTDesc: 'Menggabungkan teknik chiropractic terbaik dari AS, Jepang, Australia, Kanada untuk perawatan komprehensif',
  methodS: 'Stretching',
  methodSSub: 'Peregangan & Penyesuaian Struktural',
  methodSDesc: 'Meningkatkan struktur tubuh yang tidak seimbang secara sistematis dari tulang belakang, panggul hingga sendi tangan dan kaki',
  methodM: 'Mobility',
  methodMSub: 'Optimalisasi Mobilitas',
  methodMDesc: 'Menargetkan otot dan fascia dalam untuk meningkatkan rentang gerak dan fleksibilitas sendi',
  methodC: 'Chiro',
  methodCSub: 'Chiropractic yang Dipersonalisasi',
  methodCDesc: 'Merancang rencana perawatan yang dipersonalisasi berdasarkan konstitusi, gejala, dan gaya hidup individu',
  methodSystemTitle: 'Tubuh adalah Sistem Biomekanik yang Presisi',
  methodSystem1: 'Tulang terhubung dengan otot, otot menarik tulang',
  methodSystem2: 'Otot menghasilkan kekuatan, mendukung tulang, tulang mendukung seluruh tubuh',
  methodSystem3: 'Melawan gravitasi dan merespons berbagai kekuatan dalam kehidupan',
  
  // Services
  services: 'Layanan Profesional',
  servicesDesc: 'Perawatan Jalur Ganda - Chiropractic Amerika + Pijat Olahraga',
  chiro: 'Chiropractic Amerika',
  chiroService: "Specific manual methods · Daily movement care · Body awareness",
  chiroFeature1: "Manual methods adjusted to personal comfort",
  chiroFeature2: "Consider everyday movement and body-use habits",
  chiroFeature3: "Daily care for seated, standing, and physical-work lifestyles",
  chiroPrice: '$1000',
  chiroPriceSuffix: 'ke atas / 30-40 menit',
  massage: 'Chiropractic Amerika + Pijat Olahraga',
  massageService: "Manual care · Deep fascial relaxation · Post-exercise care",
  massageFeature1: "Deep muscle and fascial relaxation based on personal needs",
  massageFeature2: "Post-exercise relaxation for regularly active people",
  massageFeature3: "Whole-body relaxation for office and physical workers",
  massagePrice: '$2300',
  massagePriceSuffix: '/ 90 menit',
  suitable: 'Cocok untuk:',
  chiroSuitable: "office workers, standing workers, physical workers, and people who value daily body care",
  massageSuitable: "active people, office workers, physical workers, and those seeking post-exercise relaxation",
  
  // Services Summary
  servicesSummary1: "Two-track bodywork: manual care + massage",
  servicesSummary2: ", tailored to lifestyle and everyday relaxation needs",
  
  // Who Needs Our Services
  whoNeedsTitle: "Gaya hidup apa yang cocok untuk perawatan tubuh harian?",
  whoNeedsSubtitle: "Dikelompokkan berdasarkan gaya hidup dan penggunaan tubuh, bukan diagnosis atau pengobatan penyakit",
  
  // Target Groups
  targetOffice: "Kelompok kerja meja dan kantor",
  targetOfficeSymptom1: "Berjam-jam menggunakan komputer",
  targetOfficeSymptom2: "Aktivitas harian lebih sedikit",
  targetOfficeSymptom3: "Lama dalam satu posisi",
  targetOfficeSymptom4: "Menginginkan relaksasi leher, bahu, dan punggung",
  
  targetAthlete: "Kelompok aktif rutin",
  targetAthleteSymptom1: "Latihan kekuatan atau olahraga bola",
  targetAthleteSymptom2: "Menginginkan relaksasi setelah olahraga",
  targetAthleteSymptom3: "Mengutamakan peregangan dan perawatan harian",
  targetAthleteSymptom4: "Ingin memahami kebiasaan gerak tubuh",
  
  targetPosture: "Kelompok kerja berdiri",
  targetPostureSymptom1: "Pekerjaan membutuhkan berdiri lama",
  targetPostureSymptom2: "Sering berjalan atau mempertahankan posisi",
  targetPostureSymptom3: "Penggunaan kaki tinggi sehari-hari",
  targetPostureSymptom4: "Menginginkan relaksasi kaki dan seluruh tubuh",
  
  targetChronic: "Kelompok kerja fisik",
  targetChronicSymptom1: "Sering mengangkat atau membawa barang",
  targetChronicSymptom2: "Gerakan yang sama berulang lama",
  targetChronicSymptom3: "Beban fisik harian tinggi",
  targetChronicSymptom4: "Menginginkan relaksasi otot seluruh tubuh",
  
  targetSenior: "Kelompok komuter dan pengemudi",
  targetSeniorSymptom1: "Mengemudi atau berkendara berjam-jam setiap hari",
  targetSeniorSymptom2: "Sering melakukan perjalanan atau komuter jarak jauh",
  targetSeniorSymptom3: "Pekerjaan mengharuskan posisi mengemudi tetap",
  targetSeniorSymptom4: "Ingin relaksasi seluruh tubuh saat waktu istirahat",
  
  targetPregnant: "Kelompok perawatan tubuh rutin",
  targetPregnantSymptom1: "Tidak memiliki kebutuhan pengobatan khusus",
  targetPregnantSymptom2: "Mengutamakan relaksasi dan perawatan diri",
  targetPregnantSymptom3: "Ingin memahami kebiasaan gerak harian",
  targetPregnantSymptom4: "Menjadwalkan perawatan tubuh rutin",
  
  // About Us
  aboutTitle: 'Dari Insinyur menjadi Terapis Tubuh',
  aboutSubtitle: 'Filosofi dan Metode',
  aboutPara1: 'Pola pikir insinyur adalah mengejar',
  aboutPara1Highlight: '"menyelesaikan masalah dari akarnya"',
  aboutPara1b: '. Seperti men-debug kode, kami tidak hanya menangani gejala nyeri, tetapi mencari penyebab akar dari ketidakseimbangan struktural.',
  aboutPara2: 'Setiap penyesuaian seperti mengompilasi ulang kode struktural tubuh. Kami menggabungkan teknik terbaik dari',
  aboutPara2Highlight: 'AS, Jepang, Australia, dan Kanada',
  aboutPara2b: ', menggunakan presisi seorang insinyur untuk memberikan optimalisasi terdalam untuk tubuh Anda.',
  aboutPara3: 'Di Jiali, Tainan, kami menawarkan lebih dari pijat tradisional. Kami memberikan',
  aboutPara3Highlight: 'perawatan tubuh yang sistematis',
  aboutPara3b: ' yang menggabungkan anatomi modern, biomekanika, dan ilmu olahraga.',
  aboutQuote: 'Tubuh adalah sistem biomekanik yang presisi. Yang dibutuhkan bukan perbaikan sementara, tetapi rekonstruksi struktural yang sistematis. Kami menggunakan pemikiran logis insinyur yang dikombinasikan dengan teknik profesional untuk membantu setiap klien mendapatkan kembali kondisi tubuh yang optimal.',
  aboutQuoteAuthor: '— Pendiri TSMC',
  
  // FAQ
  faqTitle: 'Pertanyaan yang Sering Diajukan',
  faqSubtitle: 'Tentang Tainan Jiali Chiropractic & Pijat',
  
  // FAQ Q&A
  faq1Q: 'Apa perbedaan Chiropractic Amerika dengan pijat tradisional?',
  faq1A: 'Chiropractic Amerika berfokus pada "keselarasan sendi tulang", memulihkan mobilitas sendi normal melalui teknik yang tepat untuk meningkatkan mekanika tubuh secara fundamental. Pijat tradisional berfokus pada pembukaan meridian dan relaksasi otot. TSMC menggabungkan keduanya untuk perawatan komprehensif.',
  
  faq2Q: 'Apakah tidak nyaman? Apakah aman?',
  faq2A: 'Teknik kami dilatih secara profesional. Anda mungkin merasakan sedikit peregangan atau tekanan ringan, tetapi tidak akan menyebabkan rasa sakit. Semua operasi berada dalam batas aman dan disesuaikan dengan kondisi Anda.',
  
  faq3Q: 'Seberapa sering saya harus datang?',
  faq3A: 'Tergantung pada kondisi individu. Untuk kasus akut, direkomendasikan 1-2 kali per minggu. Untuk masalah kronis, awalnya mungkin perlu sesi yang lebih sering (sekali seminggu), kemudian dapat diperpanjang hingga setiap 2-4 minggu untuk pemeliharaan. Kami akan memberikan saran profesional berdasarkan situasi Anda.',
  
  faq4Q: 'Apa yang perlu saya bawa pada kunjungan pertama?',
  faq4A: 'Disarankan mengenakan pakaian yang nyaman dan longgar. Jika pernah melakukan pemeriksaan tubuh (X-ray, MRI, dll.), silakan bawa untuk referensi. Kami akan melakukan evaluasi tubuh yang detail sebelum merancang rencana perawatan yang dipersonalisasi.',
  
  faq5Q: 'Bagaimana Anda menghitung biaya?',
  faq5A: 'Chiropractic Amerika mulai dari $1000 (30-40 menit), Chiropractic + Pijat Olahraga $2300 (90 menit). Harga transparan tanpa biaya tersembunyi. Untuk yang pertama kali, kami merekomendasikan untuk memulai dengan Chiropractic Amerika sehingga kami dapat menilai kondisi Anda dan menyarankan layanan yang sesuai.',
  
  faq6Q: 'Bisakah saya datang dari luar Tainan Jiali?',
  faq6A: 'Tentu saja! Kami melayani klien dari semua area Tainan, termasuk Jiali, Madou, Xuejia, Jiangjun, Qigu, Xigang, Anding, dll. Transportasi nyaman dengan navigasi Google Maps.',
  
  // Reviews
  reviewsTitle: 'Umpan Balik Nyata dari Pelanggan',
  reviewsSubtitle: 'Dari Pelanggan Berharga Kami dengan Ulasan 5 Bintang',
  reviewsDisclaimer: 'TSMC bukan institusi medis. Kutipan ulasan pelanggan Google di bawah ini hanya mencerminkan pengalaman pribadi pengulas dan bukan merupakan klaim atau jaminan TSMC mengenai hasil medis atau layanan.',
  reviewsViewAll: 'Lihat Semua Ulasan Google',
  reviewsFrom: 'Sumber',
  
  // Training
  trainingTitle: 'Pelatihan Internasional',
  trainingSubtitle: 'Pengembangan Profesional Berkelanjutan',
  trainingIntro: 'Selama bertahun-tahun, terus belajar dari instruktur profesional di seluruh dunia, terus meningkatkan keahlian teknis dan membawa konsep chiropractic canggih kembali ke Taiwan.',
  trainingYear: '',
  trainingStats1: 'Pembelajaran Berkelanjutan',
  trainingStats1Val: '10+ Tahun',
  trainingStats2: 'Instruktur Internasional',
  trainingStats2Val: '10+ Master',
  trainingStats3: 'Pelatihan Lintas Batas',
  trainingStats3Val: 'Berkali-kali',
  
  // CTA
  ctaTitle: "Siap menjadwalkan perawatan tubuh harian?",
  ctaDesc: "Pilih bodywork non-medis sesuai gaya hidup dan kebutuhan relaksasi",
  ctaBooking: 'Pesan Online',
  ctaLine: 'Konsultasi Online LINE',
  ctaTransparent: 'Harga Transparan',
  ctaTransparentDesc: 'Tanpa Biaya Tersembunyi\nHarga Jelas',
  ctaCert: 'Bersertifikat Profesional',
  ctaCertDesc: 'Teknik dari\nBerbagai Negara',
  ctaFlex: 'Pemesanan Fleksibel',
  ctaFlexDesc: 'Sistem Online\nCepat & Mudah',
  
  // Footer
  footerHours: 'Jam Kerja',
  footerHoursDays: 'Sabtu sampai Rabu',
  footerHoursTime: '11:00 AM - 9:40 PM',
  footerHoursClosed: 'Tutup Kamis & Jumat',
  footerLocation: 'Lokasi',
  footerLocationCity: 'Distrik Jiali, Kota Tainan',
  footerLocationAddr: 'No. 130-95, Anxi, Desa Wenxin',
  footerLocationMap: 'Navigasi Google Maps',
  footerLocationSearch: 'Buka lokasi TSMC Chiro Studio langsung di Google Maps',
  footerLocationGuide: 'Tidak perlu mencari alamat. Ketuk tombol di bawah untuk navigasi langsung.',
  footerLocationOpenMap: 'Buka Navigasi Google Maps Langsung',
  footerContact: 'Kontak',
  footerContactLine: 'Akun LINE Resmi',
  footerFollow: 'Ikuti Kami',
  footerServices: 'Layanan',
  footerService1: 'Chiropractic Amerika',
  footerService2: 'Peningkatan Mobilitas Sendi',
  footerService3: 'Pijat Olahraga',
  footerService4: 'Pelepasan Fascia Dalam',
  footerService5: 'Penyesuaian Panggul',
  footerService6: 'Evaluasi & Optimalisasi Postur',
  footerDisclaimer: 'Pemberitahuan Penting:',
  footerDisclaimerText: "TSMC menyediakan bodywork tradisional dan pijat olahraga non-medis untuk relaksasi, perawatan tubuh, dan kesadaran tubuh. Kami tidak mendiagnosis atau mengobati penyakit dan tidak menyediakan rehabilitasi. Untuk nyeri menetap, mati rasa, kelemahan, pusing, cedera akut, atau dugaan kondisi medis, konsultasikan terlebih dahulu dengan dokter berlisensi.",
  footerBookingBtn: '🎯 Pesan Online Sekarang',
  footerCopyright: '© 2026 TSMC - Studio Chiropractic & Pijat Olahraga Profesional Tainan Jiali',
  footerTagline1: 'Technology of Stretching & Mobility Chiro',
  footerTagline2: 'Tainan Jiali · Chiropractic & Pijat Olahraga Profesional',

  
  // Service Flow
  serviceFlowTitle: 'Proses Layanan Kami',
  serviceFlowSubtitle: 'Dari penilaian profesional hingga penyesuaian presisi, setiap langkah memastikan kesehatan Anda',
  serviceFlowPhase1: 'Fase Penilaian',
  serviceFlowPhase2: 'Fase Penyesuaian',
  serviceFlowScrollHint: 'Geser untuk melihat proses lengkap',
  step1Title: 'Pengamatan Gerak Individual',
  step1Desc: 'Gerakan tertentu diamati sesuai kenyamanan masing-masing untuk memahami aktivitas harian dan pola penggunaan tubuh',
  step2Title: 'Penilaian Panjang Kaki',
  step2Desc: 'Pengukuran presisi perbedaan panjang panggul dan tungkai bawah untuk mengidentifikasi ketidakseimbangan struktural',
  step3Title: 'Pemeriksaan Kaki',
  step3Desc: 'Periksa distribusi tekanan telapak kaki dan status lengkungan untuk mengevaluasi masalah gaya berjalan',
  step4Title: 'Tes Tekanan',
  step4Desc: 'Menilai ketegangan otot dan mobilitas sendi untuk mengkonfirmasi area masalah',
  step5Title: 'Penyesuaian Punggung',
  step5Desc: 'Pelepasan miofasial dalam untuk memperbaiki ketidakseimbangan ketegangan otot punggung',
  step6Title: 'Penyesuaian Leher & Bahu',
  step6Desc: 'Penyesuaian presisi untuk kekakuan leher dan bahu untuk memulihkan mobilitas',
  step7Title: 'Pemeriksaan Lengkap',
  step7Desc: 'Evaluasi ulang pasca sesi untuk mengkonfirmasi perbaikan dan memberikan rekomendasi lanjutan'
};
